import { createFileRoute } from '@tanstack/react-router'

/**
 * `/tasks/{uuid}` — where every Task notification points (`TaskNotifications`). It renders nothing on
 * purpose: its whole job is to carry the Task's uuid, which the My Tasks page above reads to open that
 * Task's drawer. The bell therefore needs no knowledge of Tasks beyond following a link.
 */
export const Route = createFileRoute('/_app/tasks/$taskUuid')({
  component: () => null,
})
